import {
  IsNotEmpty,
  IsString,
  IsOptional,
  IsInt,
  IsObject,
} from 'class-validator';
import type Stripe from 'stripe';

export type IPrice = Stripe.Price;

/* -------------------------------------------------------------------------- */
/*                               Create new Price                              */
/* -------------------------------------------------------------------------- */

export class CreatePriceDto {
  @IsNotEmpty()
  @IsString()
  nickname: string;
  @IsNotEmpty()
  @IsString()
  currency: string;
  @IsNotEmpty()
  @IsInt()
  unit_amount: number;
  @IsObject()
  @IsOptional()
  recurring?: any;
  @IsString()
  @IsOptional()
  organization?: string;
}

export type CreatePriceResponse = IPrice;

/* -------------------------------------------------------------------------- */
/*                                   Update Price                              */
/* -------------------------------------------------------------------------- */

export class UpdatePriceDto {
  @IsNotEmpty()
  @IsString()
  nickname: string;
}

export type UpdatePriceResponse = IPrice;

/* -------------------------------------------------------------------------- */
/*                                  Get Price                                 */
/* -------------------------------------------------------------------------- */
export class GetPriceDto {
  
}

export type GetPriceResponse = IPrice[];
